/* 
	*	Stuff form almost most components to interect with
	*
	*/

import mitt from 'mitt';
import { toast as newToast } from "./lib/toast.svelte.ts";
import { offlinePhotoStorage } from "./lib/offlineStorage";
import { slideDecks } from "./slides/slideData";


/**
	*
	*	Helper functions to get and set local storage
	*
	*/

let getLocalStorageData = (key: any) => {
	const data = localStorage.getItem(key);
	return data ? JSON.parse(data) : null;
}

let setLocalStorageData = (key: any, value: any) => {
	localStorage.setItem(key, JSON.stringify(value));
}

/*
	*
	* yyyy is the app wide store
	*
	*/

let initialData = getLocalStorageData('yyyy');

if (initialData === null) {
	initialData =
	{
		uri: {
			api: import.meta.env.VITE_API_URL,
			test: import.meta.env.VITE_IS_TESTING
		},
		logo: {
			usage: 'wait',
			time: 877.5,
		},
		map: {
			engine: 'Maplibre',
			cardEngine: 'Leaflet',
			choose: false,
			isSatellite: false,
			tierSelector: false,
			showPrimary: true,
			showSecondary: true,
			showAdjunct: true
		},
		cards: [],
		sesh: {},
		ctrl: {},
		ui: {
			main: { centered: true },
			controls: {},
			map: {},
			menu: {}
		},
		visits: { amount: 1, prior: Date.now() },
		dev: {
			showMenu: false,
			isActive: false,
			debugLog: [],
			animateCards: false
		},
		features: {
			triageAnnotations: false
		},
		livewire_sortorder: 'default'
	};
} else {
	initialData.visits.amount = initialData.visits.amount + 1;
	initialData.visits.prior = Date.now();
}

// Force this key to be wait on start.
initialData.logo.usage = 'wait'

// Remove PGlite dependency - no longer needed
export let yyyy = $state(initialData);


type glove = {
	zoom: '+' | '-';           // zoom event carries a string
	"map-active": void;
	"map-dormant": void;
	"clear-energized": void;
	"map-click": void;
	handleLayer: string;
	handlePhase: string;
	handleSatellite: void;
	makeLarge: void;
	makeSmall: void;
	"EnergyBalance": void;
	"end Energy Balance": void;
	"showEnergyBalance": any;
	"clearEnergyBalance": void;
	// Create new livewire events
	"add-participants": void;
	"up-1": void;
	"dn-1": void;
	"refreshlivewires": void;
	"goto": string;
	"startContextDraw": void;
	"endContextDraw": void;
	"finishContextDraw": void;
	"contextPolygonComplete": any;
	"contextPolygonPoint": void;
	"clearContextPolygon": void;
	"chronicle-diff-show": { oldWireident: string; newWireident: string };
	"chronicle-diff-hide": void;
};
export let zzzz = mitt<glove>();

export let dldl = (component: string, message: string) => {
	let toBeLogged = `${new Date().toLocaleTimeString()}:[${component}]  ➔  ${message}`
	if (yyyy.dev.isActive) console.log(toBeLogged);
	yyyy.dev.debugLog = [...yyyy.dev.debugLog, toBeLogged];
};

// Subscribe to store changes to update local storage

$effect.root(() => {
	$effect(() => {
		// Create a copy without large data objects to avoid quota exceeded errors
		const dataToStore = {
			...yyyy,
			nrgzd: undefined,  // Don't store energized features data
			map: {
				...yyyy.map,
				//				idnt: undefined,  // Don't store identified features
				zote: undefined   // Don't store other large map data
			}
		};
		setLocalStorageData('yyyy', dataToStore);
	});
});


export let goto = (uri: string) => {
	dldl('store.svelte', `goto: ${uri}`);

	if (yyyy.sesh.logtoken) {
		delete yyyy.sesh.activeLivewire;
		delete yyyy.map.ident;
		delete yyyy.map.info;
	}

	//console.log("window.location.href:", window.location.href);
	//console.log("window.location.search:", window.location.search);
	yyyy.logo.usage = "wait";
	// Check if a card with the given URI exists in the array
	// Extract query parameters from URI
	const url = new URL(window.location.href);
	dldl('store.svelte', `url is ${url}`)
	const params = new URLSearchParams(url.search);
	if (params.has("show-dev-menu")) {
		dldl('store.svelte', 'dev menu requested')
		yyyy.dev.showMenu = true;
		//history.pushState({ uri: uri }, "lvwr.io", uri);
		return;
	}

	console.log("params are: ", params);
	yyyy.params = params;

	// Redirect /waitlist to /schedule-a-demo (QR codes still point to old URL)
	if (uri === '/waitlist') {
		uri = '/schedule-a-demo';
	}

	// Accept both /use-case and /use-cases
	if (uri === '/use-case') {
		uri = '/use-cases';
	}

	// Normalize trailing slash (e.g. /slides/ → /slides)
	if (uri.length > 1 && uri.endsWith('/')) {
		uri = uri.slice(0, -1);
	}

	for (let i = 0; i < yyyy.cards.length; i++) {
		yyyy.cards[i].active = false;
	}

	// Check for exact match first
	let matchingCard = yyyy.cards.find(
		(card: { uri: string }) => card.uri === uri,
	);

	// If no exact match, check if it's a learn-more sub-route
	if (!matchingCard && uri.startsWith('/learn-more/')) {
		// Extract the addon slug from the URL (e.g., /learn-more/operational-activities -> operational-activities)
		const addonSlug = uri.substring('/learn-more/'.length);

		// Validate that this is a valid addon slug
		const validSlugs = ['operational-activities', 'bills-of-quantity', 'asset-manager', 'outage-manager', 'risk-predictor'];

		if (validSlugs.includes(addonSlug)) {
			yyyy.selectedAddon = addonSlug;

			// Use the learn-more card for addon routes
			matchingCard = yyyy.cards.find(
				(card: { uri: string }) => card.uri === '/learn-more',
			);
		} else {
			// Invalid addon slug - show warning and redirect to base learn-more
			newToast.warning(`Invalid addon URL: "${addonSlug}" doesn't exist`, undefined, "top-center");
			dldl('store.svelte', `Invalid addon slug: ${addonSlug}, redirecting to /learn-more`);

			// Clear the invalid addon and go to base learn-more
			yyyy.selectedAddon = null;
			uri = '/learn-more';

			// Find the learn-more card
			matchingCard = yyyy.cards.find(
				(card: { uri: string }) => card.uri === '/learn-more',
			);

			// Update the URL to remove the invalid part
			history.replaceState({ uri: '/learn-more' }, "lvwr.io", '/learn-more');
		}
	} else if (!matchingCard && (uri.startsWith('/use-cases/') || uri.startsWith('/use-case/') || uri.startsWith('/for/'))) {
		// Extract the use case slug from the URL
		const prefix = uri.startsWith('/for/') ? '/for/' : uri.startsWith('/use-cases/') ? '/use-cases/' : '/use-case/';
		const useCaseSlug = uri.substring(prefix.length);

		// Validate that this is a valid use case slug
		const validUseCaseSlugs = ['regulatory-oversight', 'arcgis-migration', 'small-teams', 'field-documentation', 'reliability-metrics', 'outage-response', 'knowledge-transfer', 'vegetation-management', 'network-snapshots', 'energy-balance', 'data-accuracy', 'switch-validation'];

		if (validUseCaseSlugs.includes(useCaseSlug)) {
			yyyy.selectedUseCase = useCaseSlug;

			// Use the use-cases card for these routes
			matchingCard = yyyy.cards.find(
				(card: { uri: string }) => card.uri === '/use-cases',
			);
		} else {
			// Invalid use case slug - show warning and redirect to base use-cases
			newToast.warning(`Invalid use case URL: "${useCaseSlug}" doesn't exist`, undefined, "top-center");
			dldl('store.svelte', `Invalid use case slug: ${useCaseSlug}, redirecting to /use-cases`);

			// Clear the invalid use case and go to base use-cases
			yyyy.selectedUseCase = null;
			uri = '/use-cases';

			// Find the use-cases card
			matchingCard = yyyy.cards.find(
				(card: { uri: string }) => card.uri === '/use-cases',
			);

			// Update the URL to remove the invalid part
			history.replaceState({ uri: '/use-cases' }, "lvwr.io", '/use-cases');
		}
	} else if (!matchingCard && uri.startsWith('/invoice/')) {
		matchingCard = yyyy.cards.find(
			(card: { uri: string }) => card.uri === '/invoice',
		);
	} else if (!matchingCard && uri.startsWith('/slides/')) {
		const slideSlug = uri.substring('/slides/'.length);

		const validSlideSlugs = slideDecks.map(deck => deck.slug);

		if (validSlideSlugs.includes(slideSlug)) {
			yyyy.selectedSlide = slideSlug;

			matchingCard = yyyy.cards.find(
				(card: { uri: string }) => card.uri === '/slides',
			);
		} else {
			newToast.warning(`Invalid slide URL: "${slideSlug}" doesn't exist`, undefined, "top-center");
			dldl('store.svelte', `Invalid slide slug: ${slideSlug}, redirecting to /`);

			yyyy.selectedSlide = null;
			uri = '/';

			matchingCard = yyyy.cards.find(
				(card: { uri: string }) => card.uri === '/',
			);

			history.replaceState({ uri: '/' }, "lvwr.io", '/');
		}
	} else {
		// Clear selected addon, use case, and slide if not on a sub-route
		yyyy.selectedAddon = null;
		yyyy.selectedUseCase = null;
		yyyy.selectedSlide = null;
	}

	if (matchingCard) {
		matchingCard.active = true;
		yyyy.Card = matchingCard.component;
		history.pushState({ uri: uri }, "lvwr.io", uri);
		//window.location.href = uri;
	} else {
		newToast.error(`404: Page not found.`, undefined, "top-center");
		console.log("error 404");
		yyyy.cards[0].active = true;
		yyyy.selectedAddon = null;
		yyyy.selectedUseCase = null;
		history.pushState({ uri: "/" }, "lvwr.io", "/");
		yyyy.Card = yyyy.cards[0].component;
	}
};


if (window.location.host.includes('localhost')) {
	dldl('store.svelte', 'On localhost. Setting dev.isActive = true');
	yyyy.dev.isActive = true;
}


if (yyyy.dev.isActive) {
	newToast.info(`API: ${yyyy.uri.api}`, 8000, 'top-center', 'vertical');
}


// Export sync function for use in App component
export const syncOfflinePhotos = async () => {
	if (!yyyy.isOnline || !yyyy.sesh?.logtoken?.token) return;

	try {
		// Get all unuploaded photos using new storage
		const photos = await offlinePhotoStorage.getUnuploadedPhotos();

		if (!photos || photos.length === 0) return;

		console.log(`Found ${photos.length} offline photos to sync`);

		for (const photo of photos) {
			try {
				// Get presigned URL
				const uploadResponse = await fetch(`${yyyy.uri.api}/rpc/annotation_photo_upload`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: "Bearer " + yyyy.sesh.logtoken.token,
					},
					body: JSON.stringify({
						filename: `photo_${photo.id}_${Date.now()}.jpg`,
						filetype: 'image/jpeg',
						wireident_param: photo.wireident
					})
				});

				if (!uploadResponse.ok) throw new Error('Failed to get upload URL');

				const uploadData = await uploadResponse.json();

				// Convert dataUrl to blob
				const blob = await fetch(photo.data_url).then(r => r.blob());

				// Upload to S3
				const formData = new FormData();
				Object.entries(uploadData.data.fields).forEach(([key, value]) => {
					formData.append(key, value as string);
				});
				formData.append('file', blob, 'photo.jpg');

				try {
					const s3Response = await fetch(uploadData.data.url, {
						method: 'POST',
						body: formData
					});

					// S3 uploads typically return 204 (No Content) on success, not 200
					if (!s3Response.ok && s3Response.status !== 204) {
						throw new Error(`Failed to upload photo: ${s3Response.status}`);
					}
				} catch (error) {
					// Handle CORS errors - if it's a NetworkError, the upload likely succeeded
					if (error instanceof TypeError && error.message.includes('NetworkError')) {
						console.log('Upload succeeded but CORS blocked response - this is expected');
						// Continue as if successful since the upload actually worked
					} else {
						throw error; // Re-throw other errors
					}
				}

				// Mark as uploaded using new storage
				await offlinePhotoStorage.markAsUploaded(photo.id!, uploadData.url);

				console.log(`Successfully synced photo ${photo.id}`);

			} catch (error) {
				console.error(`Failed to sync photo ${photo.id}:`, error);
				// Continue with next photo
			}
		}

		newToast.success(`Synced ${result.rows.length} offline photos`);

	} catch (error) {
		console.error('Error syncing offline photos:', error);
	}
};

dldl('store.ts', 'lvwr.io start up.')


